import Marquee from "react-fast-marquee";
import { useLanguage } from "@/i18n/LanguageContext";

export const MarqueeBand = () => {
  const { t } = useLanguage();

  return (
    <section
      data-testid="marquee-section"
      className="overflow-hidden border-y border-white/10 bg-ink py-10 md:py-14"
    >
      <Marquee speed={32} gradient={false} pauseOnHover={false}>
        {t.marquee.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="text-stroke-thin mx-8 whitespace-nowrap font-display text-5xl font-black uppercase tracking-tight md:mx-14 md:text-8xl">
              {item}
            </span>
            <span className="inline-block h-3 w-3 rotate-45 bg-gold md:h-4 md:w-4" />
          </span>
        ))}
      </Marquee>
    </section>
  );
};
